import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { useEffect } from 'react';
import { DEFAULT_FORM_STATE } from '../constants/defaultFormState';
import { selectDefaultFormState } from '../selectors';
import { IFormState, TElement } from '../types/calculator';
import { useCalculatorCustomEvents } from './useCalculatorCustomEvents';

export const useCalculatorForm = (formScheme: TElement[], formRef: HTMLFormElement | null) => {
  const preselectedFormValues = useSelector(selectDefaultFormState);

  const reactHookForm = useForm<IFormState>({
    mode: 'onChange',
  });

  const { formState, getValues, reset } = reactHookForm;
  const formValues = getValues();

  // установка дефолтных значение при инициализации
  useEffect(() => {
    reset({
      ...DEFAULT_FORM_STATE,
      ...preselectedFormValues,
    });
  }, [preselectedFormValues, reset]);

  // TODO: данный хук добавляет дополнительные рендеры, нужно оптимизировать
  useCalculatorCustomEvents({ formValues, formState, eventTarget: formRef, formScheme });

  return { reactHookForm };
};
